/* CCC Relaunch 2027 – Jackson (KI-Berater, Shopify-Chat) aus allen Seiten öffnen.
   Der Chat bietet keine dokumentierte Schnittstelle, um eine Frage vorzubelegen.
   Deshalb: Chat öffnen, Frage in die Zwischenablage legen und das offen sagen.
   CCC 2026-10-03 (SimGym-Befund): Früher ging es ohne gefundenen Chat-Knopf per
   Weiterleitung auf die Jackson-Seite. Nach dem ersten Öffnen liegt der Knopf aber eine
   Shadow-DOM-Ebene tiefer (shopify-agent-runtime) – die alte Suche fand ihn nicht mehr,
   und Kundinnen landeten mitten im Kauf auf einer anderen Seite. Jetzt:
   - Knopf in allen Shadow-Ebenen suchen; ist der Chat schon offen, nicht wieder zuklappen.
   - Lädt der Chat noch, bis ca. 3 s warten.
   - Nie mehr wegleiten: ohne Chat erscheint ein Hinweis auf der Seite (Hilfe + Mail).
   - Ereignisse ccc:jackson_open / ccc:jackson_fallback über Shopify.analytics.publish.
   Rückgängig: diese Datei aus dem Theme «CCC Leseleiste fix – 2026-10-02» übernehmen. */
(function () {
  if (window.cccJacksonReady) return;
  window.cccJacksonReady = true;

  var T = window.ccc27T || {};
  function tr(k, d, v) {
    var s = T[k] || d;
    if (v) Object.keys(v).forEach(function (x) { s = s.split('{' + x + '}').join(v[x]); });
    return s;
  }
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MAIL = 'office@coffeecoachingclub.ch';

  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('ccc:' + name, data || {});
      }
    } catch (e) {}
  }

  function chatHost() {
    return document.querySelector('shopify-chat, inbox-online-store-chat, #ShopifyChat');
  }

  function deepFind(root, sel, depth) {
    if (!root || depth > 5) return null;
    var hit = root.querySelector(sel);
    if (hit) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var h = deepFind(all[i].shadowRoot, sel, depth + 1);
        if (h) return h;
      }
    }
    return null;
  }

  function findLauncher() {
    var host = chatHost();
    if (!host) return null;
    var root = host.shadowRoot || host;
    return deepFind(root, 'button[part="activator"]', 0) || root.querySelector('button, [role="button"]');
  }

  function chatIsOpen(host, launcher) {
    if (host && host.hasAttribute('open')) return true;
    return !!(launcher && launcher.getAttribute('aria-expanded') === 'true');
  }

  function note(el, text) {
    if (!el) return;
    el.textContent = text;
  }

  function link(href, text) {
    var a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    return a;
  }

  /* Hinweis, wenn der Chat nicht verfügbar ist – auf der Seite, ohne Weiterleitung */
  function fallback(noteEl, q) {
    var box = noteEl;
    if (!box) {
      box = document.getElementById('ccc-jackson-toast');
      if (!box) {
        box = document.createElement('div');
        box.id = 'ccc-jackson-toast';
        box.className = 'ccc-jackson-toast';
        box.setAttribute('role', 'status');
        document.body.appendChild(box);
      }
      clearTimeout(box._t);
      box._t = setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 12000);
    }
    box.textContent = '';
    box.appendChild(document.createTextNode(
      tr('fb_text', 'Jackson lädt gerade nicht.') + ' ' +
      (q ? tr('fb_copied', 'Deine Frage ist kopiert.') + ' ' : '') +
      tr('fb_alt', 'Du erreichst uns auch hier:') + ' '
    ));
    box.appendChild(link(ROOT.replace(/\/$/, '') + '/pages/hilfe', tr('fb_help', 'Hilfe-Seite')));
    box.appendChild(document.createTextNode(' · '));
    box.appendChild(link('mailto:' + MAIL, MAIL));
    track('jackson_fallback', { path: location.pathname, has_question: !!q });
  }

  /* CCC 2026-10-14 (QA-Bericht): Frage direkt an Jackson übergeben. Der Shopify-Chat bietet dafür
     shopify-chat.sendStarterMessage(text, 'typed') (braucht einen Klick, max. 500 Zeichen) – die Frage erscheint
     im Chat und Jackson antwortet. Fehlt die Methode oder schlägt sie fehl: bisheriger Weg (Chat öffnen,
     Frage in die Zwischenablage, klare Anleitung zum Einfügen). */
  function openJackson(question, noteEl) {
    var q = (question || '').trim();
    var host = chatHost();
    if (q && host && typeof host.sendStarterMessage === 'function') {
      try {
        var sent = host.sendStarterMessage(q.slice(0, 500), 'typed');
        note(noteEl, tr('sent', 'Deine Frage ist bei Jackson. Die Antwort erscheint im Chatfenster.'));
        track('jackson_open', { path: location.pathname, has_question: true, mode: 'starter' });
        if (sent && typeof sent.catch === 'function') sent.catch(function () { openJacksonLegacy(q, noteEl); });
        return;
      } catch (e) {}
    }
    openJacksonLegacy(q, noteEl);
  }

  function openJacksonLegacy(q, noteEl) {
    if (q && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(q).catch(function () {});
    }
    var tries = 0;
    (function attempt() {
      var host = chatHost();
      var launcher = findLauncher();
      if (launcher) {
        if (!chatIsOpen(host, launcher)) launcher.click();
        note(noteEl, q
          ? tr('paste', 'Jackson ist offen. Deine Frage ist in der Zwischenablage: Tippe unten ins Eingabefeld des Chats und füge sie ein.')
          : tr('opened', 'Jackson ist offen.'));
        track('jackson_open', { path: location.pathname, has_question: !!q });
        return;
      }
      if (tries++ < 12) { setTimeout(attempt, 250); return; }
      fallback(noteEl, q);
    })();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ccc-ask]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    openJackson(input ? input.value : '', form.parentElement.querySelector('[data-ccc-note]'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ccc-jackson]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('.ccc27');
    openJackson(btn.getAttribute('data-ccc-jackson'), scope ? scope.querySelector('[data-ccc-note]') : null);
  });

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* Jackson-Kasten auf der Produktseite direkt hinter die Kaufknöpfe schieben */
    document.querySelectorAll('[data-ccc-move-after]').forEach(function (el) {
      var meta = el.closest('.product-single__meta');
      if (!meta) return;
      var sels = el.getAttribute('data-ccc-move-after').split(',');
      for (var i = 0; i < sels.length; i++) {
        var target = meta.querySelector(sels[i].trim());
        if (!target) continue;
        var top = target;
        while (top.parentElement && top.parentElement !== meta) top = top.parentElement;
        if (top.parentElement === meta) meta.insertBefore(el, top.nextSibling);
        break;
      }
    });

    /* CCC 2026-10-03: Ausverkauft → bestellbare Alternativen direkt unter den Kaufknopf,
       vor den Jackson-Kasten (snippets/ccc27-soldout-alts). */
    var alts = document.querySelector('.product-single__meta .ccc-soldout-alts');
    var phelp = document.querySelector('.product-single__meta .ccc27-phelp');
    if (alts && phelp && phelp.parentNode) phelp.parentNode.insertBefore(alts, phelp);

    /* Suchfeld in der Kopfzeile: klarer Platzhalter */
    document.querySelectorAll('.ccc27-hsearch input[type="search"], .ccc27-hsearch .search__input').forEach(function (input) {
      input.setAttribute('placeholder', tr('search_ph', 'Maschine, Mühle, Marke oder Ersatzteil'));
    });

    /* CCC 2026-10-03: Jackson-Seite mit ?frage= (alte Links, Lesezeichen): Frage zeigen,
       Chat mit einem Klick öffnen und den Weg zurück anbieten. */
    if (/\/pages\/jackson-ki-berater\/?$/.test(location.pathname)) {
      var fq = '';
      try { fq = (new URLSearchParams(location.search).get('frage') || '').trim(); } catch (e) {}
      var main = document.getElementById('MainContent');
      if (fq && main) {
        var box = document.createElement('div');
        box.className = 'ccc27 ccc-jq';
        var h = document.createElement('p');
        h.className = 'ccc-jq__h';
        h.textContent = tr('jq_title', 'Deine Frage an Jackson');
        var qp = document.createElement('p');
        qp.className = 'ccc-jq__q';
        qp.textContent = '«' + fq + '»';
        var row = document.createElement('div');
        row.className = 'ccc-jq__row';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ccc-jq__btn';
        b.setAttribute('data-ccc-jackson', fq);
        b.textContent = tr('jq_open', 'Jackson mit dieser Frage öffnen');
        row.appendChild(b);
        var ref = '';
        try { var r = new URL(document.referrer); if (r.origin === location.origin && !/jackson-ki-berater/.test(r.pathname)) ref = r.href; } catch (e) {}
        if (ref) {
          var back = link(ref, tr('jq_back', '← Zurück zur vorherigen Seite'));
          back.className = 'ccc-jq__back';
          row.appendChild(back);
        }
        var n = document.createElement('p');
        n.className = 'ccc27-note';
        n.setAttribute('data-ccc-note', '');
        n.setAttribute('aria-live', 'polite');
        box.appendChild(h);
        box.appendChild(qp);
        box.appendChild(row);
        box.appendChild(n);
        main.insertBefore(box, main.firstChild);
      }
    }
  });
})();

/* CCC 2026-09-27: Preis-Hinweis (z. B. Linea Micra «CHF 1.00 = Beratungsgespräch») bleibt
   nach einer Variantenwahl stehen. Der Hinweis kommt aus der Produktbeschreibung und hängt
   am Preis; die Variantenwahl baut den Preis neu und nahm den Hinweis mit. */
(function () {
  if (window.cccPriceHintReady) return;
  window.cccPriceHintReady = true;
  if (!document.body || !/template-product/.test(document.body.className)) return;
  var PRICE = ['.block-price__regular', '.price__regular', '.price-item--regular', '.product__price', '.price--large', '.price'];
  var kept = null;
  var timer = null;
  function price() {
    for (var i = 0; i < PRICE.length; i++) { var p = document.querySelector(PRICE[i]); if (p) return p; }
    return null;
  }
  function check() {
    var cur = document.getElementById('ccc-price-hint');
    if (cur) { kept = cur; return; }
    if (!kept) return;
    var p = price();
    if (p && p.parentNode) p.parentNode.insertBefore(kept, p.nextSibling);
  }
  function start() {
    check();
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(check, 60); })
      .observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();

/* CCC 2026-09-27: Solange das Cookie-Fenster offen ist, bleibt der Chat-Knopf weg.
   Mobil liegt der Knopf am unteren Rand und würde sonst «Ablehnen» verdecken. */
(function () {
  if (window.cccConsentWatch) return;
  window.cccConsentWatch = true;
  var root = document.documentElement;
  var started = Date.now();
  function check() {
    var d = document.getElementById('shopify-pc__banner');
    var open = !!(d && d.offsetHeight > 0 && getComputedStyle(d).display !== 'none');
    root.classList.toggle('ccc-consent-open', open);
    if ((d && !open && Date.now() - started > 3000) || Date.now() - started > 300000) {
      clearInterval(timer);
      document.addEventListener('click', function () { setTimeout(check, 300); }, true);
    }
  }
  var timer = setInterval(check, 500);
  check();
})();

/* CCC 2026-10-16 (Journey-Analyse, SimGym 6/30: Chat überdeckt die Seite und «kommt wieder»):
   Geprüft: Der Shopify-Chat merkt sich, ob er offen war, und öffnet sich auf der nächsten Seite von selbst
   wieder (nach dem Schliessen bleibt er zu). Auf dem Handy deckt er dann die neue Seite ab.
   Jetzt: Auf schmalen Bildschirmen wird ein so wiederhergestellter Chat beim Laden zugeklappt (host.close(),
   wie wenn man ihn selbst schliesst); mit einem Tipp auf den Chat-Knopf geht er wieder auf.
   Geprüft wird nur in den ersten 8 s nach dem Laden (alle 200 ms).
   Nicht betroffen: Desktop (ab 769 px, gleiche Grenze wie die Kaufleiste), die Jackson-Seite, und jedes Öffnen
   über Chat, Jackson-Fragen oder Kaufleiste auf dieser Seite (Tippen, Klicken, Tastatur).
   Hinweis: open-Attribut und close() sind keine dokumentierte Shopify-Schnittstelle; fehlen sie, passiert nichts.
   Rückgängig: diesen Block entfernen. */
(function () {
  if (window.cccChatCalm) return;
  window.cccChatCalm = true;
  if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
  if (/\/pages\/jackson-ki-berater\/?$/.test(location.pathname)) return;
  var byUser = false;
  function fromChat(e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (!n || n.nodeType !== 1) continue;
      if (n.tagName === 'SHOPIFY-CHAT' || n.hasAttribute('data-ccc-jackson') || n.hasAttribute('data-ccc-sbar-chat') || n.hasAttribute('data-ccc-ask')) return true;
    }
    return false;
  }
  function mark(e) { if (fromChat(e)) byUser = true; }
  var EV = ['pointerdown', 'keydown', 'click', 'submit'];
  EV.forEach(function (n) { document.addEventListener(n, mark, true); });
  function done() {
    clearInterval(timer);
    EV.forEach(function (n) { document.removeEventListener(n, mark, true); });
  }
  var started = Date.now();
  var timer = setInterval(function () {
    if (byUser || Date.now() - started > 8000) { done(); return; }
    var host = document.querySelector('shopify-chat');
    if (host && host.hasAttribute('open') && typeof host.close === 'function') {
      done();
      try { var p = host.close(); if (p && typeof p.catch === 'function') p.catch(function () {}); } catch (err) {}
    }
  }, 200);
})();

/* CCC 2026-10-16 (Journey-Analyse, Clarity: Filter geklickt, «nichts passiert»): Das Theme wartet nach einem
   Filterklick 0,8 s, bevor es neu lädt, und zeigt erst dann den Ladebalken. Jetzt erscheint derselbe
   Ladebalken (Klasse unload) sofort beim Klick. Rückgängig: diesen Block entfernen. */
(function () {
  if (window.cccFilterPending) return;
  window.cccFilterPending = true;
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('filter-form')) return;
    var grid = document.querySelector('.collection-grid__wrapper');
    if (!grid) return;
    grid.classList.add('unload');
    grid.setAttribute('aria-busy', 'true');
    clearTimeout(grid._cccPending);
    /* Falls kein Neuladen folgt: Balken nach 5 s wieder weg (beim Neuladen ersetzt das Theme den Inhalt).
       Lädt das Theme noch (item-grid.isAnimating, langsames Netz), weiter warten – höchstens 20 s. */
    var ig = grid.closest('item-grid'), waited = 0;
    var later = function () {
      if (!grid.isConnected) return;
      if (ig && ig.isAnimating && waited < 15000) { waited += 1000; grid._cccPending = setTimeout(later, 1000); return; }
      grid.classList.remove('unload');
      grid.removeAttribute('aria-busy');
    };
    grid._cccPending = setTimeout(later, 5000);
  }, true);
})();
